function reportWindowSize() {
  const isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');
  const battleCardsSliderScrollContainer = document.getElementById('battleCardsSliderScrollContainer');

  if (isTablet.matches && battleCardsSliderScrollContainer) {
    const battleCardsSliderScrollContainerScrollWidth = battleCardsSliderScrollContainer.scrollWidth;
    const battleCardsSliderButtonLeft = document.getElementById('battleCardsSliderButtonLeft');
    const battleCardsSliderButtonRight = document.getElementById('battleCardsSliderButtonRight');

    if (battleCardsSliderScrollContainer) {
      battleCardsSliderButtonLeft.onclick = () => {
        battleCardsSliderScrollContainer.scrollLeft -= battleCardsSliderScrollContainerScrollWidth;
        battleCardsSliderButtonLeft.disabled = true;
        battleCardsSliderButtonLeft.classList.add('disabled');
        battleCardsSliderButtonRight.disabled = false;
        battleCardsSliderButtonRight.classList.remove('disabled');
      };

      battleCardsSliderButtonRight.onclick = () => {
        battleCardsSliderScrollContainer.scrollLeft += battleCardsSliderScrollContainerScrollWidth;
        battleCardsSliderButtonLeft.disabled = false;
        battleCardsSliderButtonLeft.classList.remove('disabled');
        battleCardsSliderButtonRight.disabled = true;
        battleCardsSliderButtonRight.classList.add('disabled');
      };
    }
  }
}

window.onload = reportWindowSize;

window.onresize = reportWindowSize;
